export default {
  namespaced: true,
  state: {
    authList: [], // 认证列表
  },
  getters: {
    authList: state => state.authList,
  },
  mutations: {
    // 更新申请列表
    updateAuthList(state, data) {
      console.log('shujulaile')
      console.log(data)
      state.authList = data;
    }
  },
  actions: {},
};
